import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Do I need an appointment?',
  answer: 'No, we accept walk-ins all day. But if you prefer to secure your spot, you can call 862-388-9571.'
}, {
  question: 'Do you serve children?',
  answer: "Yes, we're experts with all types of clients, from the youngest to the most discerning."
}, {
  question: 'How long does the service take?',
  answer: "Between 30 and 60 minutes depending on the service. Your transformation won't be rushed."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-28">
          <h2 className="font-display text-3xl md:text-4xl text-gold mb-4" data-id="element-29">
            Frequently Asked Questions
          </h2>
          <div className="h-[1px] w-16 bg-gold/30 mx-auto" data-id="element-30"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-31">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="border border-white/10 rounded-lg overflow-hidden bg-matte" data-id="element-32">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-33">
                  <span className="font-display text-lg md:text-xl text-white" data-id="element-34">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-35" />
                </button>

                <AnimatePresence data-id="element-36">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-37">
                      <div className="px-6 pb-5 pt-0" data-id="element-38">
                        <p className="font-body text-cream/80 font-light leading-relaxed" data-id="element-39">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}